import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ImageNodeView } from './image-resizer';

const UpdatedImage = Image.extend({
  name: 'image',
  addAttributes() {
    return {
      // @ts-expect-error parent exists at runtime via TipTap's extension chain
      ...this.parent?.(),
      width: {
        default: null,
      },
      height: {
        default: null,
      },
      fileId: {
        default: null,
      },
    };
  },
  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, unknown> }) {
    return ['img', { ...HTMLAttributes, style: 'cursor: default;' }];
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
});

export default UpdatedImage;
